import { render, staticRenderFns } from "./SinglePage.vue?vue&type=template&id=4efb0705&"
import script from "./SinglePage.vue?vue&type=script&lang=js&"
export * from "./SinglePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports